import { TextField } from "react-admin";
import { EmptyState } from "../components/EmptyState";
import {
  AppList,
  AppListDefaultActions,
  AppListFilterCard,
  AppDatagrid,
  SearchFilterInput,
  AppRowActions,
  ListEditButton,
} from "@/adapters/inbound/layout";

export const AddressList = () => (
  <AppList
    perPage={25}
    sort={{ field: "updatedAt", order: "DESC" }}
    empty={
      <EmptyState
        title="Noch keine Adressen"
        hint="Adressen werden beim Anlegen von Kunden, Einsatzorten oder Aufträgen erfasst."
        hasCreate={false}
      />
    }
  >
    <AppListDefaultActions hasCreate={false} />

    <AppListFilterCard
      search={<SearchFilterInput source="q" label="Suche" alwaysOn />}
    />

    <AppDatagrid rowClick="show">
      <TextField source="label" label="Bezeichnung" sortable />
      <TextField source="street" label="Straße" sortable />
      <TextField source="streetNumber" label="Nr." />
      <TextField source="zip" label="PLZ" sortable />
      <TextField source="city" label="Ort" sortable />
      <TextField source="country" label="Land" sortable emptyText="—" />
      <AppRowActions>
        <ListEditButton />
      </AppRowActions>
    </AppDatagrid>
  </AppList>
);
